import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit } from '@angular/core';
import { Location } from '@angular/common'
import { GlobalsService } from '../../services/globals.service'
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, UntypedFormGroup, ValidatorFn, AbstractControl } from '@angular/forms';

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-sales-people',
	templateUrl: './sales-people.component.html',
	styleUrls: ['./sales-people.component.scss']
})
export class SalesPeopleComponent implements OnInit {
	@ViewChild('salesEdit') salesEditRef: ElementRef;
	salespeople: any = [];
	managers: any = [];
	zones: any = [];
	yesno: any = [
		{ value: '0', name: 'No' },
		{ value: '1', name: 'Yes' }
	];

	salesForm: UntypedFormGroup;

	constructor(private fb: UntypedFormBuilder, private globalsService: GlobalsService, private globalSearchService: GlobalSearchService, private modalService: NgbModal) {}

	ngOnInit(): void {
		this.loadData();
		this.globalsService.getSalesManagers().subscribe((results: any) => {
			this.managers = results || [];
		});
		this.globalSearchService.zones.subscribe((results: any) => {
			this.zones = results;
		});
	}

	getIsManager(): boolean {
		const gl = this.salesForm?.get('group_level')?.value;
		return (parseInt(gl, 10) || 0) > 1;
	}

	addSalesPerson() {
		this.salesForm = this.fb.group({
			salesmancode: ['', Validators.required],
			salesmanname: ['', Validators.required],
			smantel: [''],
			smanfax: [''],
			commissionrate1: [''],
			breakpoint: [''],
			commissionrate2: [''],
			current: ['1'],
			chatid: [''],
			group_id: ['1'],
			group_level: ['0'],
			group_type: ['1'],
			username: [''],
			smanlogin: [''],
			smanpass: [''],
			smanaddr: [''],
			smancity: [''],
			smanstate: [''],
			smanzip: [''],
			smantab: [''],
			smancell: [''],
			smanemail: [''],
			access_level: ['0'],
			csremails: [''],
			commlock: ['0'],
			ismanager: [false],
			manager: [''],
			assinged_salespeople: [[]],
		});

		this.modalService.open(this.salesEditRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then(() => {}, () => {});
	}

	saveSalesPerson() {
		if (this.salesForm.valid) {
			const raw = this.salesForm.getRawValue();
			const payload = { ...raw };
			payload.group_level = payload.ismanager ? '2' : '0';
			delete payload.ismanager;
			this.globalsService.saveSalesPerson(payload).subscribe(result => {
				this.salespeople = result;
				this.modalService.dismissAll();
			});
		}
	}

	editSalesPerson(salesperson: any) {
		this.globalsService.getSalesPerson({ salesman: salesperson.salesmancode }).subscribe((detail: any) => {
			const d = detail && detail.salesmancode ? detail : salesperson;
			const gl = parseInt(d.group_level, 10) || 0;
			this.salesForm = this.fb.group({
				salesmancode: [d.salesmancode, Validators.required],
				salesmanname: [d.salesmanname, Validators.required],
				smantel: [d.smantel],
				smanfax: [d.smanfax],
				commissionrate1: [d.commissionrate1],
				breakpoint: [d.breakpoint],
				commissionrate2: [d.commissionrate2],
				current: [d.current],
				chatid: [d.chatid],
				group_id: [d.group_id],
				group_level: [d.group_level],
				group_type: [d.group_type],
				username: [d.username],
				smanlogin: [d.smanlogin],
				smanpass: [d.smanpass],
				smanaddr: [d.smanaddr],
				smancity: [d.smancity],
				smanstate: [d.smanstate],
				smanzip: [d.smanzip],
				smantab: [d.smantab],
				smancell: [d.smancell],
				smanemail: [d.smanemail, Validators.required],
				access_level: [d.access_level],
				csremails: [d.csremails],
				commlock: [d.commlock],
				ismanager: [gl > 1],
				manager: [d.manager || ''],
				assinged_salespeople: [Array.isArray(d.assinged_salespeople) ? d.assinged_salespeople : []],
			});
			this.modalService.open(this.salesEditRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then(() => {}, () => {});
		});
	}

	removeSalesPerson(salesperson: any) {
		this.globalsService.removeSalesPerson(salesperson).subscribe(result => {
			if (result.success) {
				this.loadData()
				this.globalSearchService.showNotification(result.message, 'success', 'bottom', 'right');
			} else {

				this.globalSearchService.showNotification(result.message, 'danger', 'bottom', 'right');
			}
		});

	}

	loadData() {
		this.globalsService.getSalesPeople().subscribe(results => {
			this.salespeople = results;
		});
		this.globalSearchService.zones.subscribe((results: any) => {
			this.zones = results;
		});
	}
}
